module.exports = __webpack_public_path__ + "media/src/images/logos/open_ai-a5f3ed53288499e5289b27f73c062339.png";